import { TileBase } from "../../../../../shared/model/tile-base.model";

export class PurchasePackageTile extends TileBase {
  credit: number;
  monthlyCost: number;
  billingCyclePeriod: string;
  chargedNowPrice: number;
}
